import { Suspense } from 'react'
import { AppSwitcherFallback } from '@/components/layout/breadcrumbs/app/app-switcher/fallback'
import { AppSwitcherData } from '@/components/layout/breadcrumbs/app/app-switcher/switcher'

export const AppSwitcher = () => (
  <Suspense fallback={<AppSwitcherFallback />}>
    <AppSwitcherData />
  </Suspense>
)
